module.exports = __webpack_public_path__ + "img/E2.8e80329c.svg";